module.exports = __webpack_public_path__ + "static/media/google.ba6a2220.png";